module.exports = __webpack_public_path__ + "img/category-protection.acf52b6e.svg";